module.exports = __webpack_public_path__ + "Wireframes13.png?e40264227c951d318cbbedd66b7a4e63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes13.png
// module id = 112
// module chunks = 0